import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { ReadLeadForm, UpdateLeadForm } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export type UpdateLeadFormParams = {
  landingPageId: string;
  data: UpdateLeadForm;
};

export const updateLeadForm = async (
  params: UpdateLeadFormParams,
): Promise<ReadLeadForm> => {
  return await tinctApi.leadForms.updateLeadForm(
    params.landingPageId,
    params.data,
  );
};

export const useUpdateLeadForm = (
  options?: Omit<
    UseMutationOptions<ReadLeadForm, ApiError, UpdateLeadFormParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateLeadForm,
    onSuccess: (...args) => {
      queryClient.setQueryData(['lead-form', args[1].landingPageId], args[0]);
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
